import React, { ReactNode, useEffect, useRef, useState } from 'react';
import { ID } from '../../../types/api/ID';
import { useSortableList } from './useSortableList';
import { ContentList } from '../ContentList';
import { SortableListContextProvider } from '../../DragAndDrop';
import { SonForm } from '../../Form2';
import { AnyParameter } from '../../Form2/types/SonForm';

export function useArrayEffect<T>(cb: () => void, deps: T[]) {
  const ref = useRef<T[]>(deps);
  if (JSON.stringify(deps) !== JSON.stringify(ref.current)) {
    ref.current = deps;
  }
  useEffect(cb, [ref.current]);
}

export function SortableContentList<T extends ID>({
  id,
  items,
  form,
  children,
  backgroundTransparent,
  hasDarkDragLayerBackground,
}: {
  id?: string;
  items: T[];
  form?: SonForm<AnyParameter>;
  children: (item: T) => ReactNode;
  backgroundTransparent?: boolean;
  hasDarkDragLayerBackground?: boolean;
}) {
  const [itemsList, setItemsList] = useState(items);

  /** useState does not detect changes in items array, so we have to reset state manually */
  useArrayEffect(() => setItemsList(items), items);

  const { sortableItems, ...context } = useSortableList([itemsList, setItemsList], form);

  return (
    <SortableListContextProvider {...context} hasDarkDragLayerBackground={hasDarkDragLayerBackground}>
      <ContentList id={id} modifier={backgroundTransparent ? 'background-transparent' : null}>
        {sortableItems.map(children)}
      </ContentList>
    </SortableListContextProvider>
  );
}
